export default __webpack_public_path__ + "static/media/ic_somalia.6be34a21.svg";